module.exports = __webpack_public_path__ + "img/572.991edc9d.jpg";